<template>
    <common-modal :heading="$t('modals.complete_profile.heading')" :headingCenter="true" width="wide">
        <common-content-spacer height="medium">
            <p class="description">{{ $t('modals.complete_profile.description') }}</p>
            <common-step-progressbar
                :isClickable="true"
                :steps="progressbarSteps"
                :currentStep="progressbarCurrentStep"
                @go-to-step="goToStep"
            ></common-step-progressbar>

            <common-content-wrapper v-show="progressbarCurrentStep === 0" width="medium">
                <form-wrapper @form-submit="submit">
                    <form-row>
                        <form-cell width="half">
                            <text-input
                                :formData="data"
                                :label="$t('forms.user.profile.fields.first_name.label')"
                                :placeholder="$t('forms.user.profile.fields.first_name.placeholder')"
                                :isRequired="true"
                                type="text"
                                name="firstName"
                                valuePath="firstName"
                                @change="change"
                            ></text-input>
                        </form-cell>

                        <form-cell width="half">
                            <text-input
                                :formData="data"
                                :label="$t('forms.user.profile.fields.last_name.label')"
                                :placeholder="$t('forms.user.profile.fields.last_name.placeholder')"
                                :isRequired="true"
                                type="text"
                                name="lastName"
                                valuePath="lastName"
                                @change="change"
                            ></text-input>
                        </form-cell>
                    </form-row>

                    <template #footer>
                        <common-buttons>
                            <common-button
                                :isProcessing="isLoading"
                                type="primary"
                                :label="$t('common.microcopy.next')"
                            ></common-button>
                        </common-buttons>
                    </template>
                </form-wrapper>
            </common-content-wrapper>

            <common-content-wrapper v-show="progressbarCurrentStep === 1" width="medium">
                <change-phone-form v-if="!showVerify" :prefill="data" @success="phoneSaved"></change-phone-form>
                <verify-phone-form
                    v-if="showVerify"
                    :isSmsSent="isSmsSent"
                    @success="emitEvent({ name: 'close' })"
                    @sms-countdown-over="emitEvent({ name: 'sms-countdown-over' })"
                ></verify-phone-form>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'
    import VerifyPhoneForm from 'components/forms/user/VerifyPhoneForm'
    import ChangePhoneForm from 'components/forms/user/ChangePhoneForm'

    export default {
        mixins: [FormMixin],
        components: { VerifyPhoneForm, ChangePhoneForm },
        props: {},

        data() {
            return {
                progressbarCurrentStep: 0,
                showVerify: false,
                isSmsSent: false,
            }
        },

        computed: {
            progressbarSteps() {
                return [this.$t('modals.complete_profile.steps.step_1'), this.$t('modals.complete_profile.steps.step_2')]
            },
        },

        methods: {
            goToStep(step) {
                this.progressbarCurrentStep = step
            },

            submit() {
                const requst = {
                    firstName: this.data.firstName,
                    lastName: this.data.lastName,
                    description: this.$auth.getUser()?.descriptionTextContent?.originalText,
                }
                UsersAPI.updateProfile(requst).then(() => {
                    this.$auth.reloadUser()
                    this.progressbarCurrentStep = this.progressbarCurrentStep + 1
                })
            },

            phoneSaved() {
                this.$auth.reloadUser()

                if (process.env.VUE_APP_ENV !== 'prod' && process.env.VUE_APP_ENV !== 'stage') {
                    this.showVerify = true
                    this.isSmsSent = true
                } else {
                    this.emitEvent({ name: 'close' })
                }
            },
        },

        mounted() {
            this.data.firstName = this.$auth.getUser().firstName
            this.data.lastName = this.$auth.getUser().lastName
            this.data.mobile = this.$auth.getUser().pendingMobile

            if (this.$auth.getUser().firstName && this.$auth.getUser().lastName) {
                this.progressbarCurrentStep = 1
            }
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .description {
        text-align: center;
    }
</style>
